module.exports = __webpack_public_path__ + "img/KNA.614cf5e1.svg";